import React, { useMemo, useState } from "react";
import AuthService from "../../service/authService";
import "./resetPassword.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { JameoLogoMedium } from "../JameoLogo";
import { ROUTES } from "../../utils/Constant";
import { useHistory, useLocation } from "react-router";
import { getLanguage, setLanguage } from "../../utils/LocaleUtil";
import styles from "./ResetPassword.module.scss";
import { routeFormatter } from "../../utils/Formatter";

const ResetPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState();
  const [errorMsg, setErrorMsg] = useState();
  const [emailSent, setEmailSent] = useState(false);

  const onClickReset = (e) => {
    e.preventDefault();
    const data = { email: email, language: getLanguage() };
    AuthService.resetPasswordLink(data).then((res) => {
      if (res.data.status === "success") {
        setEmailSent(true);
      } else {
        res.data.message === "Invalid Email" && lang === "en"
          ? setErrorMsg(res.data.message)
          : setErrorMsg(t("forgot_password.invalid"));
      }
    });
  };

  const location = useLocation();

  const lang = useMemo(() => {
    const query = new URLSearchParams(location.search);
    let lang = query.get("lang");
    if (lang) {
      setLanguage(lang);
    } else {
      lang = getLanguage();
    }

    return lang;
  }, [location.search]);

  const history = useHistory();

  return (
    <React.Fragment>
      <div className={styles.container}>
        <Link
          to={routeFormatter(ROUTES.RESET_PASSWORD, {
            query: { lang: lang === "fr" ? "en" : "fr" },
          })}
        >
          {t("sign_in.language")}
        </Link>
        <div className={styles.authContainer}>
          <div className={styles.authDiv}>
            <div className={styles.logoDiv}>
              <JameoLogoMedium
                className={styles.logo}
                onClick={() => {
                  history.push(ROUTES.LOGIN);
                }}
              />
            </div>
            {emailSent ? (
              <React.Fragment>
                <h3>{t("forgot_password.check_mail")}</h3>
                <Link to={ROUTES.LOGIN}>{t("forgot_password.back_login")}</Link>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <h3>{t("forgot_password.forgot_password")}</h3>
                <p>{t("forgot_password.forgot_text")}</p>
                <form onSubmit={onClickReset}>
                  <input
                    type="email"
                    className="form-control"
                    required
                    placeholder={t("forgot_password.name_placeholder")}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="username"
                  />
                  <div className="error">{errorMsg}</div>
                  <input
                    type="submit"
                    value={t("forgot_password.forgot_button")}
                  />
                </form>
                <Link to={ROUTES.LOGIN}>{t("forgot_password.back_login")}</Link>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
